// extracted by mini-css-extract-plugin
export var trigger = "Trigger-module--trigger--b127c";